import { saveAs } from "file-saver";

import { downloadFileRequest } from "../../services/apis/file";

export const downloadFileHelper = (email, code, url, filename = "", fileType="") => {
    if (!url) {
        console.log("Failed to download, url is not valid");
        return;
    }
    const urlString = new URL(url);
    const pathParts = decodeURIComponent(urlString.pathname).split("/").filter(Boolean);
    const modelId = pathParts[2];
    const filePath = pathParts.slice(1).join("/");
    if (!filePath || !modelId) {
        console.log("Failed to download, file type or model id is not valid");
        return;
    }
    downloadFileRequest(email, code, {
        file_type: fileType,
        model_id: modelId,
        url: filePath,
    }).catch((e) => {
        console.log("Failed to download, error: ", e);
    });

    const ext = filePath.split(".").pop();
    if (!filename.toLocaleLowerCase().endsWith(ext.toLocaleLowerCase())) {
        filename = `${filename}.${ext}`;
    }
    saveAs(url, filename);
};

export const getFileExtensionByUrl = (value) => {
    if (!value) return "";
    const withoutQuery = String(value).split("?")[0];
    let base = withoutQuery;
    try {
        base = decodeURIComponent(new URL(withoutQuery, window.location.origin).pathname.split("/").pop() || "");
    } catch {
        base = withoutQuery.split("/").pop() || "";
    }
    const parts = base.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

export const getFileExtensionByFileName = (fileName) => (fileName.split(".").pop() || "").toLowerCase();
